<template>
  <q-btn
    v-if="visible"
    :data-test="CypressTarget('Menu')"
    :label="label"
    v-bind="quasarButtonProps"
    size="14px"
    rounded
    class="q-px-lg-md q-px-sm q-mr-sm"
    @click="$emit('click')"
  >
    <slot />
  </q-btn>
</template>
<script>
  import QuasarButtonProps from 'mixins/components/button/common/quasarButtonProps';

  export default {
    name: 'MenuButton',
    mixins: [QuasarButtonProps],
    props: {
      flat: {
        type: Boolean,
        required: false,
        default: true,
      },
      sparse: {
        type: Boolean,
        required: false,
        default: true,
      },
      label: {
        type: String,
        required: false,
        default: '',
      },
      visible: {
        type: Boolean,
        required: false,
        default: true,
      },
    },
  };
</script>
